import { render, staticRenderFns } from "./ScoreStandardConfig.vue?vue&type=template&id=1140d97c&scoped=true&"
import script from "./ScoreStandardConfig.vue?vue&type=script&lang=js&"
export * from "./ScoreStandardConfig.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStandardConfig.vue?vue&type=style&index=0&id=1140d97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140d97c",
  null
  
)

export default component.exports